import { render } from "./SignUp.vue?vue&type=template&id=e8cc2066&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"

import "./SignUp.vue?vue&type=style&index=0&id=e8cc2066&scoped=true&lang=css"
import "./SignUp.vue?vue&type=style&index=1&id=e8cc2066&lang=css"
script.render = render
script.__scopeId = "data-v-e8cc2066"

export default script